import { Action } from '@ngrx/store';

export const READY =         '[App] Ready';

/**
 * Application is ready:
 * - config loaded
 * - access token is available
 */
export class AppReadyAction implements Action {
    readonly type = READY;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions = AppReadyAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/actions/app.actions.ts